import "../App.css";
import React from "react";
import { useEffect, useRef, useState } from "react";
import { ethers } from "ethers";
import { useNavigate } from "react-router-dom";
import {
  useAddress,
  ConnectWallet,
  useContract,
  useContractWrite,
} from "@thirdweb-dev/react";
import axios from "axios";

function App() {
  /* global BigInt */
  const address = useAddress();
  const navigate = useNavigate();
  const bigtune = 'https://radio-videos.s3.us-east-2.amazonaws.com/bigtune.mp3';

  const [audio, setAudio] = useState(null);

  const errorNoEmployees = useRef();
  const errorNoLetters = useRef();

  useEffect(() => {
    setAudio(new Audio(bigtune));
    setIsPlaying(false);
  }, []);

  var callbackURL = "https://burn.biginc.business/";

  var openseaURL = "https://opensea.io/collection/biginc"

  var serverDown = false;

    const loadModal = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get("state");

    if(serverDown){
      document.getElementById("Defects").style.display = "none";
      document.getElementById("Upgrade").style.display = "none";
      document.getElementById("Claim").style.display = "none";
      document.getElementById("Down").style.display = null;
      document.getElementById("Masthead-Nav").style.display = "none";
    }
    else{
      if (state === "claim") {
        document.getElementById("Defects").style.display = "none";
        document.getElementById("Upgrade").style.display = "none";
        document.getElementById("Claim").style.display = null;
      } else if (state === "upgrade") {
        document.getElementById("Defects").style.display = "none";
        document.getElementById("Claim").style.display = "none";
        document.getElementById("Upgrade").style.display = null;
      } else if (state === "defects") {
        const token = urlParams.get("token");
        getHistory(token);
        document.getElementById("Defects").style.display = null;
        document.getElementById("Claim").style.display = "none";
        document.getElementById("Upgrade").style.display = "none";
      } else {
        navigate(`?state=claim`);
        document.getElementById("Defects").style.display = "none";
        document.getElementById("Upgrade").style.display = "none";
        document.getElementById("Claim").style.display = null;
      }
    }
  }

  const mastheadRef = useRef(null);
  const cityRef = useRef(null);

  useEffect(() => {

    const setHeightVariables = () => {
      if (mastheadRef.current && cityRef.current) {
        const mastheadHeight = mastheadRef.current.offsetHeight;
        const cityHeight = cityRef.current.offsetHeight;
        document.documentElement.style.setProperty("--masthead", `${mastheadHeight}px`);
        document.documentElement.style.setProperty("--city", `${cityHeight}px`);
      }
    }

    setHeightVariables();

    window.addEventListener("resize", setHeightVariables);

    if (address) {
      document.getElementById("Claim-Modal").classList.add("modal-open");
      document.getElementById("Masthead-Nav").style.display = null
      get(address);
      getAssets(address);
      loadModal();
      if (audio) {
        audio.play().then(() => {
          setIsPlaying(true);
        }).catch(e => {
          setIsPlaying(false);
        });
      }
    }
  }, [address]);

    const previousAddressRef = useRef();
    useEffect(() => {
      previousAddressRef.current = address;
    }, [address]);
    const previousAddress = previousAddressRef.current;

    useEffect(() => {
      if (previousAddress && !address) {
        pauseAudio()
        document.getElementById("Claim-Modal").classList.remove("modal-open");
        document.getElementById("Masthead-Nav").style.display = "none"
      }
    }, [address, previousAddress]);


  const letters = {
    address: "0x7b390a46c868CCEbF2730121faf777129B47C97c",
    abi: ["function balanceOf(address, uint256) public view returns (uint256)"],
  };

  const [supplyCount, setSupplyCount] = useState([]);
  const [minted0, setMinted0] = useState(0);

  async function get(addr) {
    const RPC =
      "https://eth-mainnet.g.alchemy.com/v2/x2clG0iamQo50Ymz3JD1IuTkvf0MGRO1";
    const provider = new ethers.providers.JsonRpcProvider(RPC);

    const letter = new ethers.Contract(letters.address, letters.abi, provider);

    var minted0 = await letter.balanceOf(address, 0);
    setMinted0(minted0);
    
    document.getElementById("Total-Letters").innerHTML = Number(minted0);

    if(Number(minted0) === 0) errorNoLetters.current.style.display=null
    else errorNoLetters.current.style.display="none"

    var minted1 = await letter.balanceOf(address, 1);
    var minted2 = await letter.balanceOf(address, 2);
    var minted3 = await letter.balanceOf(address, 3);
    var minted4 = await letter.balanceOf(address, 4);
    var minted5 = await letter.balanceOf(address, 5);

    var array = [];

    array.push(
      Number(minted0),
      Number(minted1),
      Number(minted2),
      Number(minted3),
      Number(minted4),
      Number(minted5)
    );

    setSupplyCount(array);

  }

  let openBurnModal = async () => {
    navigate(`?state=claim`);
    document.getElementById("Claim-Modal").classList.remove("modal-open");
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    await delay(250);
    document.getElementById("Claim").style.display = null;
    document.getElementById("Defects").style.display = "none";
    document.getElementById("Upgrade").style.display = "none";
    document.getElementById("Claim-Modal").classList.add("modal-open");
  };
  let openUpgradeModal = async () => {
    navigate(`?state=upgrade`);
    document.getElementById("Claim-Modal").classList.remove("modal-open");
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    await delay(250);
    document.getElementById("Upgrade").style.display = null;
    document.getElementById("Defects").style.display = "none";
    document.getElementById("Claim").style.display = "none";
    document.getElementById("Claim-Modal").classList.add("modal-open");
  };

  const [assets, setAssets] = useState([]);
  const [memory, setMemory] = useState([]);

  const [loadingAssets, setAssetsLoading] = useState(false);
  const [loadingMemory, setMemoryLoading] = useState(false);


  async function getHistory(t) {
    setMemoryLoading(true)
    document.getElementById("Employee-Number").innerHTML = "Employee #50000" + t
    try {
        const response = await axios.get(
            "https://api.biginc.business/history/" + t
        );
        if(response.data.length === 1){
          document.getElementById("No-Employee").style.display=null
          document.getElementById("Show-Number-Input").innerHTML = t;
          document.getElementById("Employee-Description").style.display="none"
          document.getElementById("Employee-Name-Number").style.display="none"
        }
        else{
          const historyData = response.data.slice(0, response.data.length - 1);
          setMemory(historyData);
        }
    } catch(e) {
        if (e.response && e.response.status === 404) { 
            document.getElementById("No-Employee").style.display=null
            document.getElementById("Show-Number-Input").innerHTML = t;
            document.getElementById("Employee-Description").style.display="none"
            document.getElementById("Employee-Name-Number").style.display="none"
        } else {
            console.error(e); 
        }
    }
    setMemoryLoading(false)
}

  async function getAssets(addr) {
    setAssetsLoading(true);
  
    const results = await axios.post(
      `https://api.thegraph.com/subgraphs/name/0x-g/big-inc`,
      {
        query: `{
          nfts(first:1000 where:{owner_contains_nocase:"` +
          addr.toLowerCase() +
          `"}) {
            id
            tokenType
            owner
            tokenId
            tokenLevel
          }
        }`,
      }
    );
  
    var assets = results.data.data.nfts;
  
    const filteredAssets = assets.filter((asset) => asset.tokenType == 0);
  
    const promises = filteredAssets.map((asset) =>
      axios.get(`https://api.biginc.business/metadata/${asset.tokenId}`)
    );
  
    const assetDataArray = await Promise.all(promises);
  
    const updatedAssets = filteredAssets.map((asset, index) => {
      const response = assetDataArray[index].data;
      const containsEmployee = response.description.includes("Welcome to BiG iNC");
      return {
        ...asset,
        image: response.image,
        name: response.name,
        attributes: response.attributes,
        oneOfOne: !containsEmployee
      };
    });
    
    if (updatedAssets.length === 0) errorNoEmployees.current.style.display = null;
    else errorNoEmployees.current.style.display = "none";
  
    setAssets(updatedAssets);
    setAssetsLoading(false);
  }

  const closeVideo = () => {
    document.getElementById("Video-Modal").style.display = "none"
    videoRef.current.pause();
    unlockScroll()
  }

  const [isPlaying, setIsPlaying] = useState(false);

  const playAudio = () => {
    audio.play();
    document.getElementById("Volume-Off").style.display="none"
    document.getElementById("Volume-On").style.display=null;
    setIsPlaying(true);
  }

  const pauseAudio = () => {
    audio.pause();
    document.getElementById("Volume-On").style.display="none"
    document.getElementById("Volume-Off").style.display=null;
    setIsPlaying(false);
  }

  const unlockScroll = () => {
    if (audio) {
      playAudio()
    }
    document.documentElement.style.overflow = "";
    document.body.scroll = "yes";
  }

  const lockScroll = () => {
    if (audio) {
      pauseAudio()
    }
    document.documentElement.style.overflow = 'hidden';
    document.body.scroll = 'no';
  }

  const { contract } = useContract(
    "0x895688bf87D73cc7dA27852221799D31B027e300"
  );
  const { mutateAsync: upgrade } = useContractWrite(contract, "upgrade");
  const { mutateAsync: claim } = useContractWrite(contract, "claim");

  const upgradeToken = async (tokenId) => {
    try {
      var id = `number-${tokenId}`;
      var imageId = `image-${tokenId}`;
      lockScroll()
      document.getElementById(id).innerHTML = "Rerolling...";
      document.getElementById("Tx-Button").innerHTML = 'Transaction Pending&nbsp;<span class="text-loading">...</span>';
      document.getElementById("Video-Modal").style.display = null
      videoRef.current.play();
      document.getElementById(id).classList.add("disabled");
      const data = await upgrade({ args: [tokenId] });
      console.info("contract call success", data);
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await delay(1000);
      document.getElementById(imageId).src = "i/loading.gif";
      document.getElementById("Tx-Button").classList.remove("disabled-video")
      document.getElementById("Tx-Button").innerHTML = 'View Asset';
      document.getElementById(id).classList.remove("disabled");
      document.getElementById(id).innerHTML = "Reroll";
      getAssets(data.receipt.from);
      get(data.receipt.from);
    } catch (err) {
      closeVideo()
      console.error("contract call failure", err);
      document.getElementById(id).classList.remove("disabled");
      document.getElementById(id).innerHTML = "Reroll";
    }
  };

  const viewDefects = (token) => {
    window.location.href=`?state=defects&token=${token}`
  };

  const viewDefectsInput = () => {
    var tokenInput = document.getElementById("Employee-Number-Input").value
    if(tokenInput > 500000){
      tokenInput = tokenInput - 500000
    }
    window.location.href=`?state=defects&token=${tokenInput}`
  };

  const removeDisabledInput = () => {
    var input = document.getElementById("Employee-Number-Input").value;
    var button = document.getElementById("Employee-Number-Input-Button");
    if(input != "") {
        button.classList.remove("disabled");
        button.innerHTML = "View Defected (#" + input + ")";
    } else {
        button.classList.add("disabled");
        button.innerHTML = "View Defected";
    }
  }

  const videoRef = useRef();

  const claimToken = async (applicationId) => {
    try {
      var id = `Burn-Token`;
      var amount = 1;
      lockScroll()
      document.getElementById("Tx-Button").innerHTML = 'Transaction Pending&nbsp;<span class="text-loading">...</span>';
      document.getElementById("Video-Modal").style.display = null
      videoRef.current.play();
      document.getElementById("Supply-Counter").style.display = "none";
      document.getElementById("Left").style.display = "none";
      document.getElementById("Right").style.display = "none";
      document.getElementById(id).classList.add("disabled");
      document.getElementById(id).innerHTML = "Burning...";
      document.getElementById(id).classList.add("disabled");
      const data = await claim({ args: [applicationId, amount] });
      console.info("contract call success", data);
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await delay(1000);
      document.getElementById("Asset").src = "i/loading.gif";
      document.getElementById("Tx-Button").classList.remove("disabled-video")
      document.getElementById("Tx-Button").innerHTML = 'View Asset';
      getToken(data.receipt.events[1].args[1]._hex);
      document.getElementById(id).style.display = "none";
      document.getElementById("Burn-Again").style.display = null;
      document.getElementById("View-Asset").style.display = null;
    } catch (err) {
      console.error("contract call failure", err);
      closeVideo()
      document.getElementById("Supply-Counter").style.display = null;
      document.getElementById("Left").style.display = null;
      document.getElementById("Right").style.display = null;
      document.getElementById(id).classList.remove("disabled");
      document.getElementById(id).innerHTML = "Burn Token";
      document.getElementById(id).classList.remove("disabled");
    }
  };

  async function getToken(id) {
    var token = BigInt(id);
    const response = await axios.get(
      "https://api.biginc.business/metadata/" + token
    );
    document.getElementById("Asset").src = response.data.image;
    document.getElementById("Asset-Name").innerHTML = response.data.name;
    document.getElementById("View-Asset").href = "https://opensea.io/assets/ethereum/0x895688bf87D73cc7dA27852221799D31B027e300/" + token
    document.getElementById("Asset-Description").innerHTML =
      response.data.description;
  }

  const [currentIndex, setCurrentIndex] = useState(0);
  const isSupplyZero = supplyCount[currentIndex] === 0;

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const refresh = () => {
    window.location.reload();
  }

  const viewOpensea = () => {
    window.open(openseaURL, '_blank');
  }

  const images = [
    "i/big_inc_acceptance_general.png",
    "i/big_inc_acceptance_believer.png",
    "i/big_inc_acceptance_goblin.png",
    "i/big_inc_acceptance_puzzler.png",
    "i/big_inc_acceptance_c_suite.png",
    "i/janitor_keyring.png",
  ];

  return (
    <>
      <div id="Experience" className="hero-observed">
        <div id="Masthead" ref={mastheadRef}>
          <a href={callbackURL} id="Logo">
            <svg className="logo-wordmark" viewBox="0 0 226 53">
              <path
                className="logo-symbol"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.4444 0.573524H45.5556L44.9223 9H55.0777L54.4444 0.573524ZM55.3031 12H44.6969L42 47.8895L50 52.1945L58 47.8895L55.3031 12Z"
                fill="#010505"
              />
              <path
                d="M28.7808 23.5863V23.2995C31.5184 22.9411 36.713 21.1488 36.713 13.6213C36.713 5.80695 30.8165 0.573524 20.7783 0.573524H0V47.8895H22.0418C32.08 47.8895 38.117 43.588 38.117 35.1285C38.117 27.3859 31.9396 23.873 28.7808 23.5863ZM23.5862 15.0551C23.5862 18.1378 21.4101 19.5716 17.7598 19.5716H12.7758V10.1801H17.5492C21.4101 10.1801 23.5862 12.1157 23.5862 15.0551ZM19.3042 38.2829H12.7758V28.5329H19.0936C22.5332 28.5329 24.8497 30.612 24.8497 33.4796C24.8497 36.7057 22.7438 38.2829 19.3042 38.2829Z"
                fill="#010505"
              />
              <path
                d="M205.374 6.10352e-05C192.119 6.10352e-05 182.55 9.32096 182.55 24.2344C182.55 39.0761 192.19 48.4688 206.792 48.4688C217.282 48.4688 223.307 42.7328 226.001 38.9328L218.204 30.6156C216.786 32.6232 213.1 36.9252 207.146 36.9252C201.405 36.9252 195.947 33.2685 195.947 24.2344C195.947 16.4192 200.129 11.5436 205.587 11.5436C211.399 11.5436 213.525 16.6343 213.525 20.9362L225.717 19.0721C225.717 10.1814 220.259 6.10352e-05 205.374 6.10352e-05Z"
                fill="#010505"
              />
              <path
                d="M176.6 0.573654H163.912V19.1438C163.912 23.0155 163.912 26.7439 164.267 28.2496L163.841 28.4647C162.92 26.7439 160.014 21.94 158.029 19.1438L144.632 0.573654H134.142V47.8952H146.83V31.1175C146.83 27.2458 146.83 24.0193 146.475 22.5136L146.971 22.2985C148.743 25.1665 150.87 28.393 152.784 31.1175L164.763 47.8952H176.6V0.573654Z"
                fill="#010505"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M126.207 47.8952H113.306V12H126.207V47.8952ZM126.207 9H113.306V0.573654H126.207V9Z"
                fill="#010505"
              />
              <path
                d="M105.641 25.0918H84.7223V32.4042H94.4094C93.7777 36.0605 90.9698 37.6377 86.3368 37.6377C80.0191 37.6377 75.9476 32.2609 75.9476 24.2315C75.9476 16.4172 80.0893 11.5422 85.4944 11.5422C91.2506 11.5422 93.3565 15.9154 93.3565 20.2168L105.43 18.3528C105.43 10.1801 100.025 0 85.2838 0C72.157 0 62.6804 9.3198 62.6804 24.2315C62.6804 39.1432 71.1743 48.463 83.9501 48.463C89.4255 48.463 93.3565 46.6707 95.9538 43.7314C96.0942 46.0972 96.375 47.4593 96.4452 47.8895H105.641V25.0918Z"
                fill="#010505"
              />
            </svg>
          </a>

          <nav id="Masthead-Nav" style={{ display: "none" }}>
            <button id="Apply-Job" onClick={() => openBurnModal()}>
              <i className="fa-solid fa-handshake"></i>
              <span>Accept Job</span>
            </button>
            <button id="Request-New" onClick={() => openUpgradeModal()}>
              <i className="fa-solid fa-refresh"></i>
              <span>Request New Job</span>
            </button>
          </nav>
          <div id="Masthead-Controls">
          <a href="https://opensea.io/collection/biginc" id="Opensea" target="_blank" className="icon">
                        <img src="i/gt-os-icon.png"/>
            </a>
            <button id="Volume" className="icon" onClick={isPlaying ? pauseAudio : playAudio} style={isPlaying ? {} : { animation: "none" }}>
              <img className="off" id="Volume-Off" style={isPlaying ? {display: "none"} : {}} src="i/gt-volume-icon-off.png" />
              <img className="on" id="Volume-On" style={isPlaying ? {} : {display: "none"}} src="i/gt-volume-icon-on.png" />
            </button>
            <ConnectWallet
              className="connect-button"
            />
          </div>

        </div>

        <div id="Hero">
          <div id="Big-Mister" className="over no-touch">
            <img loading="lazy" src="i/big-mister-red.gif" />
          </div>
          <div id="Big-Mister-Halo" className="over no-touch">
            <img loading="lazy" src="i/big-mister-halo.png" />
          </div>
          <div id="Goblintown" className="no-touch" ref={cityRef}>
            <div id="City-Background" className="over">
              <img loading="lazy" src="i/city-background.png" />
            </div>
            <div id="City-Midground" className="over">
              <img loading="lazy" src="i/city-midground.png" />
            </div>
            <div id="Big-Inc" className="over">
              <div id="Infestation" className="animation-layer">
                <img src="i/infestation.gif" />
              </div>
              <div id="Building-Door" className="over">
                <img loading="lazy" src="i/building-door.png" />
              </div>
              <div id="Building">
                <img loading="lazy" src="i/building.png" />
              </div>
            </div>
            <div id="City-Foreground" className="over">
              <img loading="lazy" src="i/city-foreground.png" />
            </div>
            <div id="City-Lights" className="over">
              <img
                loading="lazy"
                src="https://goblintown.wtf/i/GT-town-layer-3.png"
              />
            </div>
            <div id="City" className="over">
              <img loading="lazy" src="i/city.png" />
            </div>
          </div>
        </div>

        <div id="Video-Modal" style={{ display: "none" }}>
          <div className="video-wrapper">
            <video ref={videoRef} controls playsInline loop>
              <source src="https://radio-videos.s3.us-east-2.amazonaws.com/Big+Inc+conveyor+belt+V7.mp4" type="video/mp4" />
              <source src="https://radio-videos.s3.us-east-2.amazonaws.com/Big+Inc+conveyor+belt+V7.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>
            <button id="Tx-Button" className="video-button btn disabled-video" onClick={closeVideo}></button>
          </div>
        </div>

        <div id="Claim-Modal" className="modal claim-modal">
          <div id="Claim" className="claim-state" style={{ display: "none" }}>
            <div className="claim-header">
              <h2>Accept a Job</h2>
              <p className="large">Accept a Job by trading in an <strong>Acceptance Letter</strong>, and a personalized Assignment will be assigned to you based on your personality, height, weight, age, smell, and intelligence!</p>
            </div>
            <div className="claim-choice">
              <div className="modal-asset">
                <div className="modal-img-holder">
                  <img id="Asset" src={images[currentIndex]} alt="Image" />
                  <p id="Supply-Counter">Your Balance: {supplyCount[currentIndex]}</p>
                </div>
                  <h4 id="Asset-Name" className="letter-title"></h4>
                  <p id="Asset-Description"></p>
                  <a id="View-Asset" target="_blank" className="icon" style={{ display: "none"}}>
                        <img style={{maxHeight:"50px"}} src="i/gt-os-icon.png"/>
                    </a>
              </div>
              <div className="modal-buttons">
                <button id="Left" className="btn" onClick={handlePrev}><i className="fa fa-angle-left"></i></button>
                <button id="Right" className="btn" onClick={handleNext}><i className="fa fa-angle-right"></i></button>
                <div className="modal-action">
                  <button id="Burn-Token" className={isSupplyZero ? "btn disabled" : "btn"} onClick={() => claimToken([currentIndex])}>Burn Token</button>
                  <button id="Burn-Again" style={{ display: "none" }} className="btn" onClick={refresh}>Accept Another Job</button>
                </div>
              </div>
            </div>
          </div>
          <div id="Upgrade" className="claim-state" style={{ display: "none" }}>
            <div className="claim-header">
              <h2>Request New Job</h2>
              <p className="large">When you request a new Job, you will be assigned a new Employee, and the metadata will update for your original NFT.</p>
              <p className="large">You will need to trade in <strong>1 General Acceptance Letter</strong>.</p>
              <p><strong>Total General Acceptance Letters: <span id="Total-Letters"></span></strong></p>
            </div>
            <div id="Employee-Number-Checker" className="card">
              <input id="Employee-Number-Input" type="number" placeholder="Input Employee #" onInput={removeDisabledInput}></input>
              <button id="Employee-Number-Input-Button" className="btn disabled" onClick={viewDefectsInput}>View Defected</button>
            </div>
            <div className="count-errors">
              <div ref={errorNoEmployees} style={{display:"none"}}  className="error card">
                <p className="large">You haven't created a <strong>General Employee</strong> yet. You'll need to trade a <strong>General Acceptance Letter</strong> first! Go ahead and accept your first job at BiG iNC&trade; to get started.</p>
                <button className="btn" onClick={openBurnModal}>Accept a Job</button>
              </div>
              <div ref={errorNoLetters} style={{display:"none"}}  className="error card">
                <p className="large">You don't have any <strong>General Acceptance Letters</strong> to request a new job. You need at least one <strong>General Employee</strong> and one <strong>Acceptance Letter</strong> to request a new job.</p>
                <a href="https://opensea.io/collection/biginc-letters" target="_blank" className="btn">Buy More Letters</a>
              </div>
            </div>
            <div className="claim-choice">
            {loadingAssets ? (
          <p className="large">Loading General Employees<span className="text-loading">...</span></p>
                ) : (
                            assets.map((asset, index) => (
                              <div key={index} className={`upgrade-choice ${asset.oneOfOne ? "OneOfOne-Card" : ""}`}>
                                <div className="modal-img-holder">
                                  <p className="helper-count">Helped Defect: {asset.tokenLevel}</p>

                                <img
                                id={`image-${asset.tokenId}`}
                                  src={asset.image}
                                  alt="Image"
                                    loading="lazy"
                                />
                                  <p className="employee-name">{asset.name}</p>

                                </div>
                                <div className="upgrade-buttons">
                                <button
                                      id={`number-${asset.tokenId}`}
                                      className={`btn reroll-btn ${asset.oneOfOne ? "OneOfOne-Button" : ""}`}
                                      onClick={() => upgradeToken(asset.tokenId)}
                                      disabled={minted0 === 0 || asset.oneOfOne}
                                    >
                                      {asset.oneOfOne ? "Reroll Disabled (1/1)" : "Reroll"}
                                </button>
                                <button
                                    className={`btn ${asset.tokenLevel === 0 ? "disabled" : ""
                                  }`}
                                  onClick={() => viewDefects(asset.tokenId)}
                                  disabled={asset.tokenLevel === 0}
                                >
                                  View Defected
                                </button>
                                </div>
                              </div>
                            ))
                        )}
            </div>
          </div>
          <div id="Defects" className="claim-state" style={{ display: "none" }}>
            <div className="claim-header">
              <h2 id="Employee-Name-Number"><span id="Employee-Number"></span> Defected Characters</h2>
              <p id="Employee-Description" className="large">Look at all the eager Employees you've wasted. They could've been strong, meaningful contributions to BiG iNC, and you just threw them away. Despicable.</p>
              <p id="No-Employee" style={{display:"none"}} className="large">Employee #<span id="Show-Number-Input"></span> has not defected any Employees yet.</p>
              <button id="Save-More" className="btn" onClick={() => openUpgradeModal()}>
                <span>Save More Employees</span>
              </button>
            </div>

            <div className="claim-choice">
            {loadingMemory ? (
          <p className="large">Loading Defected Employees<span className="text-loading">...</span></p>
                ) : (
              memory.map((asset, index) => (
                <div key={index} className="modal-img-holder">
                  <img
                    src={asset.image}
                    alt="Image"
                    loading="lazy"
                  />
                  <p className="defected-name">{asset.name}</p>
                </div>
              ))
              )}
            </div>
          </div>

          <div id="Down" className="claim-state" style={{ display: "none" }}>
            <div className="claim-header">
              <h2 id="Employee-Name-Number"><span id="Employee-Number"></span> Servers are down</h2>
              <p id="Employee-Description" className="large">Too many new employees! BiG iNC servers are overloaded and are currently down. Please try again soon.</p>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default App;
